import { render, staticRenderFns } from "./add-citizen-form.vue?vue&type=template&id=62d75ca0"
import script from "./add-citizen-form.vue?vue&type=script&lang=ts"
export * from "./add-citizen-form.vue?vue&type=script&lang=ts"
import style0 from "./add-citizen-form.vue?vue&type=style&index=0&id=62d75ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports